module.exports = "/images/walmart.svg?6a2131adcc8a64037fc551b615f414bb";